import React, { ReactNode } from 'react'
import LesaTourV2PurchaseSummary from './LesaTourV2PurchaseSummary'
import { isBundleAndSaveOrder, isVillaOrder } from 'lib/order/orderUtils'
import LesaCruisePurchaseSummary from './LesaCruisePurchaseSummary'
import LesaStandaloneFlightPurchaseSummary from './LesaStandaloneFlightPurchaseSummay'
import LesaExperiencePurchaseSummary from './LesaExperiencePurchaseSummary'
import LesaHotelPurchaseSummary from './LesaHotelPurchaseSummary'
import LesaVillaPurchaseSummary from './LesaVillaPurchaseSummary'
import LesaCarHirePurchaseSummary from './LesaCarHirePurchaseSummary'
import LesaBedbankPurchaseSummary from './LesaBedbankPurchaseSummary'
import LesaBundleAndSavePurchaseSummary from './LesaBundleAndSavePurchaseSummary'
import { isCurrentOrCloseToCheckIn } from 'lib/order/isUpcoming'
import LesaExperienceAirportTransferSummary from './LesaExperienceAirportTransferSummary'

interface Props {
  order: App.Order
  isPastOrder?: boolean
  hideSelect?: boolean
  actions?: Array<App.ChatMessageMetaContent>
  payload?: App.ChatMessageMetaPayload
  componentsMap: Map<string | undefined, App.ChatMessageMetaContent>
}

function LesaPurchaseSummary(props: Props) {
  const { order, isPastOrder, hideSelect, actions, payload, componentsMap } = props
  const isCurrentOrder = isCurrentOrCloseToCheckIn(order)
  const canEdit = !!order?.accessDetails?.canEdit

  const commonProps = {
    isPastOrder: !!isPastOrder,
    isCurrentOrder,
    order,
    hideSelect,
    actions,
    payload,
    componentsMap,
    canEdit
  }

  let component: ReactNode = null
  if (order.items.length > 0) {
    if (isBundleAndSaveOrder(order)) {
      component = <LesaBundleAndSavePurchaseSummary {...commonProps} />
    } else if (isVillaOrder(order)) {
      component = <LesaVillaPurchaseSummary {...commonProps} />
    } else {
      component = <LesaHotelPurchaseSummary {...commonProps} />
    }
  } else if (order.customOfferItems.length > 0) {
    return null
  } else if (order.bedbankItems.length > 0) {
    component = <LesaBedbankPurchaseSummary {...commonProps} />
  } else if (order.tourItems.length > 0) {
    component = <LesaTourV2PurchaseSummary {...commonProps} />
  } else if (order.cruiseItems.length > 0) {
    // Currently, it is only possible to reserve one cabin per order. That is, there will always be only one item
    component = <LesaCruisePurchaseSummary {...commonProps} bookingId={order.cruiseItems[0].bookingId} />
  } else if (order.experienceItems.length > 0) {
    component = <LesaExperiencePurchaseSummary {...commonProps} />
  } else if (order.flightItems.length > 0) {
    component = <LesaStandaloneFlightPurchaseSummary {...commonProps} />
  } else if (order.transferItems.length > 0) {
    component = <LesaExperienceAirportTransferSummary {...commonProps} />
  } else if (order.carHireItems.length > 0) {
    component = <LesaCarHirePurchaseSummary {...commonProps} />
  }

  return component
}

export default LesaPurchaseSummary
